import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useViewerCanSeeEntireCompanyScope } from '@/auth/useViewerCanSeeEntireCompanyScope';
import { Button } from '@/components';
import { Banner } from '@/components/molecules';
import { RoutesEnum } from '@/enums';
import { useAppNavigate } from '@/router/useAppNavigate';
import { useGetOrganizationQuery } from '@/store/api/organization';

const GETTING_STARTED_PAGES: string[] = [RoutesEnum.GET_STARTED];
const GETTING_STARTED_PATH_PREFIX = '/getting-started';

export const SetupIncompleteBanner: FC = () => {
  const { t } = useTranslation('components');
  const navigate = useAppNavigate();
  const { pathname } = useLocation();
  const { canSeeEntireCompanyScope } = useViewerCanSeeEntireCompanyScope();
  const { data: organizationData } = useGetOrganizationQuery();

  const isGettingStartedPage =
    GETTING_STARTED_PAGES.includes(pathname) || pathname.startsWith(GETTING_STARTED_PATH_PREFIX);

  if (
    isGettingStartedPage ||
    !canSeeEntireCompanyScope ||
    organizationData?.setupStatus?.complete !== false
  ) {
    return null;
  }

  return (
    <Banner
      title={t('setupIncompleteBanner.title')}
      description={t('setupIncompleteBanner.description')}
      rightButton={
        <Button variant="primary" size="sm" onClick={() => navigate(RoutesEnum.INTEGRATIONS)}>
          {t('setupIncompleteBanner.completeSetupMessage')}
        </Button>
      }
      variant="primary"
    />
  );
};
